<p-toast
  [key]="key"
  [life]="life"
  [styleClass]="cssClass"
  [position]="position"
  [preventOpenDuplicates]="preventOpenDuplicates"
  [preventDuplicates]="preventDuplicates"
  [showTransformOptions]="showTransformOptions"
  [showTransitionOptions]="showTransitionOptions"
  [hideTransitionOptions]="hideTransitionOptions"
  [showTransformOptions]="showTransformOptions"
>
  <ng-template let-message pTemplate="headless">
    <ng-container [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{ $implicit: message }"> </ng-container>
  </ng-template>
</p-toast>
